import QuestionsUtils from '../../utils/QuestionsUtil'
import { Business, Guarantor, SeniorStaff } from '../data/mockStore'

describe('QuestionsUtils: ', () => {
  const categoriesQuestions = 
    '{"business_questions":[300,301,302,303,304,305,306,307,308,309,310,311,312,313,315,400,401,402,405,406,407,500,501,502,504,505,506],"business_prequalify":[600,603,604],"business_prequalify_paycheck_protection":[601],"business_basic_info":[315,403,404,409,410,411,1301],"business_basic_info_payroll":[800,801,900,901],"business_story":[400,401,402,405,407],"business_loan_info":[408],"business_sba_required":[300,303,304,311,312,313,317,320,504,506,502,500,501],"business_payroll_info":[700,701,705,706],"business_payroll_funds":[702],"business_payroll_franchise":[1300],"business_payroll_revenue":[1100],"business_payroll_funds_optional":[703,704],"business_closing_payroll":[1000,1001,1002],"business_closing_payroll_ppp_second_draw":[1200],"business_operations":[303,304,311,504,1501,1502],"business_value":[312,313],"business_government_and_legal":[1601,1602,1603,1604,1606,1607],"business_affiliations":[1701,1702,1703,1704],"business_employment":[500,501],"guarantor_experience":[399,398,316],"guarantor_legal":[1,2,3,4,18,5],"guarantor_basic_info":[6],"guarantor_demographics":[220,210,230],"guarantor_sba_required":[100,103,104,105],"senior_staff_sba_required":[2,1,3,4,5]}'

  describe('Business Questions: ', () => {
    let util = new QuestionsUtils({ questions: Business.questions, entity: Business, categoriesQuestions })

    it('questions_prequalify', () => { expect(util.questions_prequalify.length).toBe(1) })

    it('questions_basic_info', () => { expect(util.questions_basic_info.length).toBe(6) })

    it('questions_story', () => { expect(util.questions_story.length).toBe(4) })

    it('questions_closing', () => { expect(util.questions_closing.length).toBe(13) })

    it('questions_payroll_revenue', () => { expect(util.questions_payroll_revenue.length).toBe(0) })

    it('questions_business_closing_payroll_ppp_second_draw', () => { expect(util.questions_business_closing_payroll_ppp_second_draw.length).toBe(0) })
  })

  describe('Guarantor Questions: ', () => {
    let utilGuarantor = new QuestionsUtils({ questions: Guarantor.questions, entity: Guarantor, categoriesQuestions })

    it('questions_basic_info', () => { expect(utilGuarantor.questions_basic_info.length).toBe(1) })

    it('questions_legal', () => { expect(utilGuarantor.questions_legal.length).toBe(6) })

    it('questions_demographics', () => { expect(utilGuarantor.questions_demographics.length).toBe(3) })

    it('questions_experience', () => { expect(utilGuarantor.questions_experience.length).toBe(3) })

    it('questions_closing', () => { expect(utilGuarantor.questions_closing.length).toBe(5) })
  })

  describe('Senior Staff Questions: ', () => {
    let utilSeniorStaff = new QuestionsUtils({ questions: SeniorStaff.questions, entity: SeniorStaff, categoriesQuestions })

    it('questions_closing', () => { expect(utilSeniorStaff.questions_closing.length).toBe(3) })
  })

  describe('Undefined Questions: ', () => {
    let undefinedUtil = new QuestionsUtils({ questions: undefined, entity: Business, categoriesQuestions })

    it('any category should be []', () => { expect(undefinedUtil.questions_closing.length).toBe(0) })
  })

  describe('#_isPaycheckProtectionSecondDrawProduct', () => {
    let { _isPaycheckProtectionSecondDrawProduct } = new QuestionsUtils({ questions: Business.questions, entity: Business, categoriesQuestions, isPaycheckProtection: true })

    it ('should return boolean', () => {
      expect(_isPaycheckProtectionSecondDrawProduct()).toBeTruthy()
    })
  })

  describe('Form 1919 v2: ', () => {
    describe('Business Questions: ', () => {
      let util1919v2Business = new QuestionsUtils({
        questions: Business.questions, entity: Business, categoriesQuestions, flowVariant: 'rfa_lite_sba_1919_v2',
      })

      it('questions_basic_info', () => { expect(util1919v2Business.questions_basic_info.length).toBe(3) })
      it('questions_closing', () => { expect(util1919v2Business.questions_closing.length).toBe(19) })
    })

    describe('Guarantor Questions: ', () => {
      let util1919v2Guarantor = new QuestionsUtils({
        questions: Guarantor.questions, entity: Guarantor, categoriesQuestions, flowVariant: 'rfa_lite_sba_1919_v2',
      })
      
      it('questions_legal', () => { expect(util1919v2Guarantor.questions_legal.length).toBe(0) })
      it('questions_closing', () => { expect(util1919v2Guarantor.questions_closing.length).toBe(0) })
    })
  })
})
